import { GrowthDataSet } from '../../types/data-set.types';

// WHO Weight-for-age BOYS
// Birth to 13 weeks (weekly measurements)
export const whoBoysWeightWeekly: GrowthDataSet = {
  id: 'who-boys-weight-weekly',
  source: 'WHO',
  title: 'Weight-for-age',
  intervalType: 'week',
  gender: 'male',
  measurementType: 'weight',
  ageRange: { min: 0, max: 13 },
  displayUnit: 'kg',
  dataPoints: [
    {
      age: 0,
      m: 3.3464,
      s: 0.14602,
      sd: 0.4887,
      percentiles: {
        p1: 2.3,
        p3: 2.5,
        p5: 2.6,
        p15: 2.9,
        p25: 3.0,
        p50: 3.3,
        p75: 3.7,
        p85: 3.9,
        p95: 4.2,
        p97: 4.3,
        p99: 4.6,
      },
    },
    {
      age: 1,
      m: 3.4879,
      s: 0.14483,
      sd: 0.5052,
      percentiles: {
        p1: 2.4,
        p3: 2.6,
        p5: 2.7,
        p15: 3.0,
        p25: 3.2,
        p50: 3.5,
        p75: 3.8,
        p85: 4.0,
        p95: 4.4,
        p97: 4.5,
        p99: 4.8,
      },
    },
    {
      age: 2,
      m: 3.7529,
      s: 0.14142,
      sd: 0.5307,
      percentiles: {
        p1: 2.7,
        p3: 2.8,
        p5: 3.0,
        p15: 3.2,
        p25: 3.4,
        p50: 3.8,
        p75: 4.1,
        p85: 4.3,
        p95: 4.7,
        p97: 4.9,
        p99: 5.1,
      },
    },
    {
      age: 3,
      m: 4.0603,
      s: 0.13807,
      sd: 0.5606,
      percentiles: {
        p1: 2.9,
        p3: 3.1,
        p5: 3.2,
        p15: 3.5,
        p25: 3.7,
        p50: 4.1,
        p75: 4.5,
        p85: 4.7,
        p95: 5.1,
        p97: 5.2,
        p99: 5.5,
      },
    },
    {
      age: 4,
      m: 4.3671,
      s: 0.13497,
      sd: 0.5894,
      percentiles: {
        p1: 3.2,
        p3: 3.4,
        p5: 3.5,
        p15: 3.8,
        p25: 4.0,
        p50: 4.4,
        p75: 4.8,
        p85: 5.0,
        p95: 5.4,
        p97: 5.6,
        p99: 5.9,
      },
    },
    {
      age: 5,
      m: 4.659,
      s: 0.13215,
      sd: 0.6157,
      percentiles: {
        p1: 3.4,
        p3: 3.6,
        p5: 3.7,
        p15: 4.1,
        p25: 4.3,
        p50: 4.7,
        p75: 5.1,
        p85: 5.3,
        p95: 5.8,
        p97: 5.9,
        p99: 6.3,
      },
    },
    {
      age: 6,
      m: 4.9303,
      s: 0.1296,
      sd: 0.639,
      percentiles: {
        p1: 3.6,
        p3: 3.8,
        p5: 4.0,
        p15: 4.3,
        p25: 4.5,
        p50: 4.9,
        p75: 5.4,
        p85: 5.6,
        p95: 6.1,
        p97: 6.3,
        p99: 6.6,
      },
    },
    {
      age: 7,
      m: 5.1817,
      s: 0.12729,
      sd: 0.6596,
      percentiles: {
        p1: 3.8,
        p3: 4.1,
        p5: 4.2,
        p15: 4.5,
        p25: 4.8,
        p50: 5.2,
        p75: 5.6,
        p85: 5.9,
        p95: 6.4,
        p97: 6.5,
        p99: 6.9,
      },
    },
    {
      age: 8,
      m: 5.4149,
      s: 0.1252,
      sd: 0.678,
      percentiles: {
        p1: 4.0,
        p3: 4.3,
        p5: 4.4,
        p15: 4.7,
        p25: 5.0,
        p50: 5.4,
        p75: 5.9,
        p85: 6.2,
        p95: 6.6,
        p97: 6.8,
        p99: 7.2,
      },
    },
    {
      age: 9,
      m: 5.6319,
      s: 0.1233,
      sd: 0.6944,
      percentiles: {
        p1: 4.2,
        p3: 4.4,
        p5: 4.6,
        p15: 4.9,
        p25: 5.2,
        p50: 5.6,
        p75: 6.1,
        p85: 6.4,
        p95: 6.9,
        p97: 7.1,
        p99: 7.4,
      },
    },
    {
      age: 10,
      m: 5.8346,
      s: 0.12157,
      sd: 0.7093,
      percentiles: {
        p1: 4.4,
        p3: 4.6,
        p5: 4.8,
        p15: 5.1,
        p25: 5.4,
        p50: 5.8,
        p75: 6.3,
        p85: 6.6,
        p95: 7.1,
        p97: 7.3,
        p99: 7.7,
      },
    },
    {
      age: 11,
      m: 6.0242,
      s: 0.12001,
      sd: 0.723,
      percentiles: {
        p1: 4.5,
        p3: 4.8,
        p5: 4.9,
        p15: 5.3,
        p25: 5.6,
        p50: 6.0,
        p75: 6.5,
        p85: 6.8,
        p95: 7.3,
        p97: 7.5,
        p99: 7.9,
      },
    },
    {
      age: 12,
      m: 6.2019,
      s: 0.1186,
      sd: 0.7355,
      percentiles: {
        p1: 4.7,
        p3: 4.9,
        p5: 5.1,
        p15: 5.5,
        p25: 5.7,
        p50: 6.2,
        p75: 6.7,
        p85: 7.0,
        p95: 7.5,
        p97: 7.7,
        p99: 8.1,
      },
    },
    {
      age: 13,
      m: 6.369,
      s: 0.11732,
      sd: 0.7472,
      percentiles: {
        p1: 4.8,
        p3: 5.1,
        p5: 5.2,
        p15: 5.6,
        p25: 5.9,
        p50: 6.4,
        p75: 6.9,
        p85: 7.2,
        p95: 7.7,
        p97: 7.9,
        p99: 8.3,
      },
    },
  ],
};
